import styled from 'styled-components'

const Address = styled.p`
  font-weight: 500;
  font-size: 0.8em;
  line-height: 15px;
  letter-spacing: -0.12px;
  margin-bottom: 12px;
`

export default Address
